import React, { useState, useEffect } from 'react';
import { Grid, List, ListItem, Checkbox } from '@mui/material';
import '../../style/common.css';
import { useTranslation } from 'react-i18next';

const BusinessUnitLocationMapping = ({dataObj, selectedItems, setSelectedItems, bunitFilterList, businessOption, isDisabled=false}) => {
  const { t } = useTranslation('common');
  const [selectedOptions, setSelectedOptions] = useState(businessOption);
  // const [selectedOptions, setSelectedOptions] = useState(['All']);

  const [locations, setLocations] = useState([]);
  const [locationsData, setLocationsData] = useState({})
  const [defaulLoc, setDefaultLoc] = useState([]);

  useEffect(()=>{
    if(bunitFilterList && bunitFilterList?.status === 200){
      const dataArr = bunitFilterList?.data || []
      let locationData = {
      }
      dataArr?.forEach(input => {
          locationData[input.businessUnitName] = input.businessLocation ? input.businessLocation : input.businessUnitLocations || []
      });
      const allLocationsArr = dataArr.flatMap(item => item.businessLocation).sort((a, b) => a.locationName.localeCompare(b.locationName));
      setLocationsData(locationData);
      setDefaultLoc(allLocationsArr)
      
    }
    },[bunitFilterList, dataObj])

        const optionList = ['All', ...Object.keys(locationsData)];
        const sortedOptionList = optionList.slice().sort((a, b) => {
        if (a === 'All') return -1;
        if (b === 'All') return 1;
        return a.localeCompare(b);
      });


    // const optionList = ['All', ...Object.keys(locationsData)];
    // const sortedOptionList = optionList?.slice().sort((a, b) => a?.localeCompare(b));
  //   useEffect(()=>{
  //     const defaultFilterLoc = bunitFilterList?.data
  // ?.flatMap(item => 
  //   item?.businessLocation?.filter(location => location) || [] // Filter out any falsy locations
  // )
  // ?.map(location => ({
  //   value: location?.id,
  //   label: location?.locationName,
  // }));

  //     console.log(defaultFilterLoc, 'dataObj')
  //     if(dataObj === "Yes") {
  //       handleSelectAll();
  //     }
  //   },[dataObj])

  useEffect(() => {
    if (selectedOptions?.includes('All') || selectedOptions?.length === 0) {
      const allLocations = Object.values(locationsData).flat();
      const sortedLocations = allLocations?.sort((a, b) => a?.locationName?.localeCompare(b.locationName));
      setLocations(sortedLocations);
    } else if(locationsData){
      const selectedLocations = selectedOptions?.flatMap(option => locationsData[option] || []);
      const sortedLocations = selectedLocations?.sort((a, b) => a?.locationName?.localeCompare(b.locationName));
      if(dataObj === "Yes") {
        setLocations(defaulLoc);
      } else {
        setLocations(sortedLocations);
      }
    }
  }, [selectedOptions, locationsData]);

  useEffect(() => {
    setSelectedOptions(businessOption)
  }, [businessOption.length]);

  // const handleOptionClick = (option) => {

  //   setSelectedOptions(prevOptions => (
  //     prevOptions?.includes(option)
  //       ? prevOptions.filter(o => o !== option)
  //       : [...prevOptions, option]
  //   ));

  //   if (option === 'All') {
  //     setSelectedOptions([option]);
  //   } else {
  //     setSelectedOptions(prevOptions => prevOptions.filter(o => o !== 'All'));
  //   }
  // };
  const handleOptionClick = (option) => {
    setSelectedOptions((prevOptions) => {
      if (option === 'All') {
        // If "All" is already selected, unselect all options; otherwise, select all options
        return prevOptions.includes('All') ? [] : sortedOptionList;
      } else {
        const updatedOptions = prevOptions.includes(option)
          ? prevOptions.filter((o) => o !== option)
          : [...prevOptions, option];

          const selectedLocations = selectedOptions?.flatMap(option => locationsData[option] || []);
          const sortedLocations = selectedLocations?.sort((a, b) => a?.locationName?.localeCompare(b.locationName));
    
          const matchingItems = selectedItems.filter(item => 
            sortedLocations.some(location => location.id === item)
        );
        setSelectedItems(matchingItems)
        
  
        // If an individual option is clicked, ensure "All" is not selected
        return updatedOptions.includes('All') ? updatedOptions.filter((o) => o !== 'All') : updatedOptions;
      }
    });
  };
  
  
  const handleToggleSelect = (itemId) => {
    if (selectedItems?.includes(itemId)) {
      setSelectedItems(selectedItems.filter((selectedItem) => selectedItem !== itemId));
    } else {
      setSelectedItems([...selectedItems, itemId]);
    }
  };

  const handleSelectAll = (checked) => {
    const allItemIds = locations?.map((item) => item.id);
    setSelectedItems(checked ? allItemIds : []);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={5}>
        <div
          style={{
            border: '1px solid #005974',
            borderRadius: 3,
            height: 249,
            overflowY: 'auto',
            paddingTop: 0,
          }}
        >
          <div
            className='s-normal'
            style={{
              padding: 15,
              background: '#F0F0F0',
              borderBottom: '2px solid #fff',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            {t("Business Units")} <span style={{ color: 'red' }}>{" *"}</span>
          </div>
          {dataObj === 'Yes' && (
            <List style={{ padding: 0 }}>
            {sortedOptionList?.map((option) => (
              <ListItem
                key={option}
                className='s-normal'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 10px',
                }}
              >
                <Checkbox
                  className='location-check'
                  id={option}
                  disabled={true}
                  checked={true}
                  onChange={() => handleOptionClick(option)}
                />
                <label htmlFor={option} style={{ marginLeft: 8 }}>
                  {option}
                </label>
              </ListItem>
            ))}
          </List>
          )}
          {dataObj === 'No' && (
            <List style={{ padding: 0 }}>
            {sortedOptionList?.map((option) => (
              <ListItem
                key={option}
                className='s-normal'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  padding: '5px 10px',
                }}
              >
                <Checkbox
                  className='location-check'
                  id={option}
                  checked={ selectedOptions?.includes(option) }
                  onChange={() => handleOptionClick(option)}
                />
                <label htmlFor={option} style={{ marginLeft: 8 }}>
                  {option}
                </label>
              </ListItem>
            ))}
          </List>
          )}
        </div>
      </Grid>
      <Grid item xs={7}>
        <div
          style={{
            border: '1px solid #005974',
            borderRadius: 3,
            height: 249,
            overflowY: 'auto',
            paddingTop: 0,
          }}
        >
          <div
            className='s-normal'
            style={{
              padding: 15,
              background: '#F0F0F0',
              borderBottom: '2px solid #fff',
              position: 'sticky',
              top: 0,
              zIndex: 1,
            }}
          >
            
            {t("Location")} <span style={{ color: 'red' }}>{" *"}</span>
          </div>
          {dataObj === 'Yes' && (
            <List style={{ padding: 0 }}>
              <ListItem style={{ padding: 0 }}>
                  <Checkbox
                  className='location-check'
                  id='All'
                  // disabled={isDisabled}
                  checked={true}
                />
                <label style={{ marginLeft: 8 }}>
                All
                </label>
              </ListItem>
            {locations.map((location) => (
              <ListItem key={location.id} style={{ padding: 0 }}>
                <Checkbox
                  className='location-check'
                  id={location.id}
                  disabled={true}
                  checked={true}
                  onChange={() => handleToggleSelect(location.id)}
                />
                <label htmlFor={location.id} style={{ marginLeft: 8 }}>
                  {location.locationName}
                </label>
              </ListItem>
            ))}
          </List>
          )}
          {dataObj === 'No' && (
            <List style={{ padding: 0 }}>
              <ListItem style={{ padding: 0 }}>
                <Checkbox
                className='location-check'
                id='All'
                disabled={isDisabled}
                checked={isDisabled ? true : selectedItems?.length === locations?.length && locations?.length > 0}
                onChange={(e) => handleSelectAll(e.target.checked)}
              />
              <label style={{ marginLeft: 8 }}>
              All
                </label>
              </ListItem>
            {locations?.map((location) => (
              <ListItem key={location.id} style={{ padding: 0 }}>
                <Checkbox
                  className='location-check'
                  id={location.id}
                  disabled={isDisabled}
                  checked={isDisabled ? true : selectedItems?.includes(location.id)}
                  onChange={() => handleToggleSelect(location.id)}
                />
                <label htmlFor={location.id} style={{ marginLeft: 8 }}>
                  {location.locationName}
                </label>
              </ListItem>
            ))}
          </List>
          )}
          
        </div>
      </Grid>
    </Grid>
  );
};

export default BusinessUnitLocationMapping;
